
export const BASEURLS = (path) => {
    return `https://satkartar.one/assets/hr/${path}`;
}

export const BASEEMPURLS = (path) => {
    return `https://satkartar.one/assets/employee/${path}`;
}